import { useEffect, useRef, useState } from 'react';

export const useLoadFinished = (loading: boolean) => {
    const [finished, setFinished] = useState(false);
    const started = useRef(false);

    useEffect(() => {
        if (loading) {
            started.current = true;
        } else if (started.current) {
            setFinished(true);
        }
    }, [loading]);

    return finished;
};
